import React from 'react'
import PropTypes from 'prop-types'
import Instance from 'highcharts'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './StackedBarChart.styles'

Instance.setOptions({
  lang: { numericSymbols: ['K', 'M', 'MM', 'MM'] }
})

/**
 * The StackedBarChart component.
 */
const StackedBarChart = props => {
  const { categories, data, id, tooltipFormatter } = props
  const options = {
    accessibility: { enabled: false },
    allowHTML: true,
    chart: { type: 'column' },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: { enabled: false }
      },
      series: {
        animation: false,
        borderWidth: 0
      }
    },
    series: data,
    title: { text: '' },
    tooltip: {
      shared: true,
      borderWidth: 1,
      formatter: tooltipFormatter,
      shadow: true
    },
    xAxis: {
      categories,
      endOnTick: false,
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
      max: 11,
      min: 0,
      startOnTick: false
    },
    yAxis: {
      title: { text: '' },
      gridLineDashStyle: 'ShortDash',
      stackLabels: {
        enabled: false
      }
    },
    legend: {
      enabled: true,
      align: 'right',
      verticalAlign: 'top',
      layout: 'horizontal',
      x: 0,
      y: 0,
      floating: true,
      backgroundColor: 'white',
      borderColor: '#CCC',
      borderWidth: 1,
      shadow: false
    }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
      </Root>
    </>
  )
}

StackedBarChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string]).isRequired,
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      color: PropTypes.string
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func.isRequired
}

export default StackedBarChart
